import { default as vacancyControl } from './vacancy_control/routes'
import { default as allocation } from './allocation/routes'
import { default as occupancyConsolidations } from './occupancy_consolidations/routes'
import { default as occupancyAlerts } from './occupancy_alerts/routes'
import { default as vacancySettings } from './vacancy_settings/routes'

export default [
    ...vacancyControl,
    ...allocation,
    ...occupancyConsolidations,
    ...occupancyAlerts,
    ...vacancySettings,
    {
        path: '/roomAllocation',
        name: 'roomAllocation',
        component: () => import ('./pages/roomAllocationRegister')
    },
    {
        path: '/roomLink',
        name: 'roomLink',
        component: () => import ('./pages/roomLinkRegister')
    },
]